import SendMessage from "./SendMessage";

export default SendMessage;
